module.exports = __webpack_public_path__ + "static/pattern_card-bcdb59dae9b86bee462122372e950d67.png";